import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { managedCompaniesSelector } from '../Settings/store/SettingsSelectors'
import FeaturesAdmin, { IFeaturesAdminProps, IFeaturesAdminDispatchProps } from './FeaturesAdmin'
import { getCompanyFeatureFlags, updateCompanyFeatureFlags } from './store/FeaturesAdminActions'
import { getFeatures, getFeaturesLoading, getFeaturesSaving } from './store/FeaturesAdminSelectors'
import { getCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminSelectors'
import { setCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminActions'
import { isSuperAdmin } from '../../common/auth/authSelectors'

const mapStateToProps = (state: IGlobalState): IFeaturesAdminProps => ({
  managedCompanies: managedCompaniesSelector(state),
  features: getFeatures(state),
  loading: getFeaturesLoading(state),
  saving: getFeaturesSaving(state),
  selectedCompanyId: getCompanyAdminSelectedCompanyId(state),
  isSuperAdmin: isSuperAdmin(state),
})

const mapDispatchToProps: IFeaturesAdminDispatchProps = {
  getCompanyFeatureFlags,
  updateCompanyFeatureFlags,
  setFeaturesSelectedCompanyId: setCompanyAdminSelectedCompanyId,
}

export default connect(mapStateToProps, mapDispatchToProps)(FeaturesAdmin)
